"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LoadingPage_module_css_1 = __importDefault(require("./LoadingPage.module.css"));
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const web_head_meta_1 = require("@snapchat/web-head-meta");
const clsx_1 = __importDefault(require("clsx"));
/**
 * Loading Page
 * Helpful for AB experiments that significantly affect the Page UI.
 * Hence to avoid flicker, you can show the Loading Page until COF is fetched
 */
function LoadingPage({ supportLightDarkTheme = true, webHeadProps, linkPreview, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [webHeadProps && (0, jsx_runtime_1.jsx)(web_head_meta_1.HeadMeta, { ...webHeadProps }), linkPreview && (0, jsx_runtime_1.jsx)(web_head_meta_1.LinkPreviewHeadMeta, { linkPreview: linkPreview }), (0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(LoadingPage_module_css_1.default.fullPage, {
                    [LoadingPage_module_css_1.default.themeStyles]: supportLightDarkTheme,
                }), children: [(0, jsx_runtime_1.jsx)(web_core_ui_1.LoadingCard, {}), (0, jsx_runtime_1.jsxs)("div", { className: LoadingPage_module_css_1.default.loadingFooter, children: [(0, jsx_runtime_1.jsx)("span", { className: LoadingPage_module_css_1.default.copyRightText, children: `© Snap Inc. ${new Date().getFullYear()}` }), (0, jsx_runtime_1.jsx)(web_sds_c_1.Typography, { variant: web_sds_c_1.TypographyVariant.Headline, children: "Snapchat" })] })] })] }));
}
exports.LoadingPage = LoadingPage;
//# sourceMappingURL=index.js.map